import { T } from '@/libs/translation';
import { Button, Typo } from '@/ui/component/atom';
import { Popup, type PopupOption } from '@/ui/component/cell';
import { html } from 'rune-ts';

export const makePopup = (
  data: { title?: string; message?: string; ok?: string; cancel?: string } = {},
  option?: PopupOption,
) => {
  const theme = document.querySelector('html')?.getAttribute('theme') ?? 'Marpple';

  return Popup.open(
    {
      title: new Typo(
        { text: html.preventEscape(data.title ?? T('common.errors.title')) },
        { typo: 'h2', weight: theme === 'Marpple' ? 'medium' : 'bold' },
      ),
      message: new Typo(
        {
          text: html.preventEscape(data.message ?? T('common.errors.message')),
        },
        theme === 'Marpple'
          ? { typo: 'p1' }
          : { typo: 'p2', color: 'gray_80', weight: theme === 'Ciety' ? 'regular' : 'medium' },
      ),
      okButton: new Button(
        { label: new Typo({ text: data.ok ?? T('common.ok') }, { typo: 'p2', weight: 'bold' }) },
        { size: 'small', color: 'primary' },
      ),
      cancelButton: data.cancel
        ? new Button(
            { label: new Typo({ text: data.cancel }, { typo: 'p2', weight: 'bold' }) },
            { size: 'small', color: 'line' },
          )
        : undefined,
    },
    { backdrop: true, animation: true, ...option },
  );
};
